import React, { useState, useEffect } from 'react';
import './AutoExplosions.css';

function AutoExplosions() {
  const [blasts, setBlasts] = useState([]);

  useEffect(() => {
    const spawn = () => {
      const id = Date.now() + Math.random();
      const x = 5 + Math.random() * 90;
      const y = 5 + Math.random() * 90;
      const size = 0.6 + Math.random() * 1;

      setBlasts(prev => [...prev, { id, x, y, size }]);
      setTimeout(() => {
        setBlasts(prev => prev.filter(b => b.id !== id));
      }, 1200);
    };

    const loop = () => {
      spawn();
      const delay = 10 + Math.random() * 190;
      timer = setTimeout(loop, delay);
    };
    let timer;
    loop();
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="auto-explosions">
      {blasts.map(b => (
        <div
          key={b.id}
          className="auto-blast"
          style={{
            left: `${b.x}%`,
            top: `${b.y}%`,
            '--s': b.size,
          }}
        >
          <div className="blast-core" />
          <div className="blast-ring" />
          {Array.from({ length: 10 }).map((_, i) => (
            <div
              key={i}
              className="blast-shard"
              style={{
                '--angle': `${i * 36}deg`,
                '--dist': `${150 + Math.random() * 180}px`,
                '--clr': i % 2 === 0 ? '#ff5500' : '#ffcc00',
              }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export default AutoExplosions;
